import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.scim-prov-instructions', {
        url: '/scim-prov-instructions',
        component: 'companyManageApplicationIntegrationDevelopersScimProvInstructions',
        resolve: {
        },
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/scim-prov-instructions/scim-prov-instructions.state.js